import {
    DIC
} from '@/const/dic'
import {
    formatterTime
} from '@/util/util'
import {
    baseUrl
} from '@/config/env';




export const productCouponDetailOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: false,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    menuWidth: '300',
    labelWidth: '160',
    // menuType:'menu',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "优惠券编号",
            prop: "couponCode",
            type: "input"
        },
        {
            label: '订单编号',
            prop: 'orderNumber',
        },
        {
            label: '推广人姓名',
            prop: 'promoteUserName'
        },
        {
            label: '推广人电话',
            prop: 'promoteUserMobile'
        },
        {
            label: '推广佣金',
            prop: 'commission'
        }, {
            label: '领取人姓名',
            prop: 'recipientName'
        },
        {
            label: '领取人电话',
            prop: 'recipientMobile'
        },
        {
            label: "领取时间",
            prop: "collectionTime",
            type: "datetime",
            sortable: true,
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "优惠券状态",
            prop: "status",
            type: "input",
            solt: true,
            addVisdiplay: false
        }

    ]
};